// react
import React, { useState } from "react";

// device-context
import { DeviceContext } from "./deviceContext";

//  DeviceContextProvider Component
const DeviceContextProvider = (props) => {
  const [deviceData, setDeviceData] = useState({});

  return (
    <DeviceContext.Provider
      value={{
        deviceData,
        setDeviceData,
      }}
    >
      {props.children}
    </DeviceContext.Provider>
  );
};

export default DeviceContextProvider;
